<template>
    <div>
        <router-view></router-view>
        <app-header></app-header>
        <main id="page-main">
            <header class="content-header">
                <div class="wrapper">
                    <h1>Bienvenue</h1>
                </div>
            </header>
            <div class="content-body">
                <div class="widgets">
                    <!--
                    <WorkspaceWidget></WorkspaceWidget>
                    -->
                </div>
            </div>
        </main>
    </div>
</template>
<script>
    import Header from '../../layouts/Header.vue'
    import PersonWidget from '../person/PersonWidget.vue'

    export default {
        name: 'Dashboard',
        data () {
            return {
                profiles: null,
                msg: 'Page FirstRoute'
            }
        },
        mounted: function(){
        },
        components: {
            'app-header': Header,
            'PersonWidget': PersonWidget
        },
        methods: {
            edit: function(id){
                this.$router.push('/person/'+id);
            },
            increment: function () {
                this.$store.commit('increment')
            },
        }
    }
</script>


// WEBPACK FOOTER //
// src/modules/dashboard/Dashboard.vue